import { render, staticRenderFns } from "./ModalCreateNewProductsList.vue?vue&type=template&id=48160522&"
import script from "./ModalCreateNewProductsList.vue?vue&type=script&lang=js&"
export * from "./ModalCreateNewProductsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports